/* template */
<template minapp="mpx" xlang="wxml"><es-layout left-arrow :layout="(['header', 'footer'])" :title="(title)" :navbarStyle="(navbarStyle)" :navbarUseWebBack="(useWebBack)" :navbarClickLeft="(goback)"><div class="page-body"><div v-for="(item, index) in (content)" :key="item.index" class="page-body__block"><div class="page-title">{{ item[titleKey] }}</div><div class="page-text"><div v-for="(text, index) in (item[listKey])" class="page-text__item">{{ text }}</div></div></div></div><div slot="footer" class="es-service__footer"><es-button block type="info" @click="showDialog" class="custom-button" :custom-class='["button-radius"].join(" ")'>联系客服</es-button></div><TsDrawer title="联系客服" :show="(isShowDialog)" :showMask="(true)" :centerTitle="(false)" :headerStyle="(headerStyle)" @close="closeDialog"><HelpDeskChat bizType="train" :onlineSource="(onlineSource)" :onlineOrderId="(onlineOrderId)" :phone="(phoneText)"/></TsDrawer></es-layout></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m3a62f3e2"}'>
  .page-body
    padding 10px 16px
    height 100%
    background #fff
    overflow-y auto
    &__block
      margin-bottom 10px
  .page-title
    font-family PingFangSC-Medium
    font-size 15px
    color #000000
    margin-bottom 10px
  .page-text
    font-family PingFangSC-Regular
    font-size 14px
    color #666666
    text-align justify
    line-height 22px
    &__item
      margin-bottom 5px
      &::before
        content ''
        display inline-block
        width 4px
        height 4px
        background #999
        border-radius 100%
        vertical-align middle
        margin-right 5px
  .page-action
    padding 15px 10px
  .custom-button
    flex 1
  .es-service__footer
    flex 1
    position relative
    padding 20px 16px
    background #fff
    box-shadow 0 -4px 20px 0 rgba(0, 0, 0, 0.04)
  .button-radius
    border-radius 8px !important
  .popup-button
    color #1473FF !important
    font-size 16px
    border-radius 8px !important
  .popuo-call
    display flex
    align-items center
    justify-content center
  .call-dialog
    padding 32px 16px 50px
    background #FFF
    border-radius 16px 16px 0 0
  .call-title
    font-family PingFangSC-Medium
    font-size 24px
    color #000
    font-weight 500
    padding-bottom 16px
  .call-item
    display flex
    padding 12px 0
    width 100%
    &+.call-item
      border-top 1px solid #EBEBEB
  .item-left
    margin-right 7px
    width 36px
    height 36px
    border-radius 8px
    display flex
    align-items center
    justify-content center
    &.inner
      background #CFC7F6
    &.global
      background #47C1FF
  .item-right
    flex 1
  .call-text
    font-family PingFangSC-Medium
    font-size 16px
    color #444
    letter-spacing 0
    font-weight 500
  .call-number
    font-family PingFangSC-Regular
    font-size 14px
    color #999
    letter-spacing 0
    font-weight 400
  .cancel-button
    margin-top 12px
    width 100%
    height 48px
    line-height 48px
    font-family PingFangSC-Medium
    font-size 16px
    color #333
    text-align center
    font-weight 500
    background rgba(0, 0, 0, 0.06)
    border-radius 8px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m3a62f3e2"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex3a62f3e2%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex3a62f3e2%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m3a62f3e2"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index3a62f3e2/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-layout':getComponent(require("../../../es-mpx-ui/lib/layout/index.mpx?isComponent&outputPath=components%2Findex2146c876%2Findex")),'es-button':getComponent(require("../../../../node_modules/@didi/es-mpx-ui/lib/button/index.mpx?isComponent&outputPath=components%2Findexbc68cb48%2Findex")),'HelpDeskChat':getComponent(require("../../../../node_modules/@didi/spring-ui/help-desk-chat/index.mpx?isComponent&outputPath=components%2Findex047c6ed7%2Findex")),'es-icon':getComponent(require("../../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'TsDrawer':getComponent(require("../../../../node_modules/@didi/spring-ui/ts-drawer/index.mpx?isComponent&outputPath=components%2Findex76c11e5c%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
